import { useRef } from 'react';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';

export const TooltipAnalytics = eventName => {
  const hasTooltipEventFired = useRef(false);
  const timeout = useRef(null);
  const trackEvent = useTrackEvent();

  return () => {
    if (!hasTooltipEventFired.current) {
      trackEvent('Conditional tile - viewed tooltip', { tile: eventName });
      hasTooltipEventFired.current = true;
    }

    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    if (hasTooltipEventFired.current && !timeout.current) {
      timeout.current = setTimeout(() => {
        hasTooltipEventFired.current = false;
      }, 1500);
    }
  };
};
